export const COOKIE_NAME = 'titv_popout_closed';
export const TITV_LIVE_NOW = 'TITV LIVE NOW';
export const COOKIE_MAX_AGE = 60 * 60 * 24;
